import L from 'leaflet';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import useLeafletLayer from './useLeafletLayer';

// Radius is in metres; style props given at top level apply at creation, pathOptions restyle later
function LeafletCircle(props) {
  const {
    center,
    radius,
    pathOptions,
    eventHandlers,
    ...styleOptions
  } = props;

  const circle = useLeafletLayer(
    () => L.circle(center, { ...styleOptions, ...pathOptions, radius }),
    eventHandlers,
  );

  useEffect(
    () => {
      if (circle) circle.setLatLng(center);
    },
    [circle, center],
  );

  useEffect(
    () => {
      if (circle && (radius !== undefined)) circle.setRadius(radius);
    },
    [circle, radius],
  );

  useEffect(
    () => {
      if (circle && pathOptions) circle.setStyle(pathOptions);
    },
    [circle, pathOptions],
  );

  return null;
}

LeafletCircle.propTypes = {
  center: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  ]).isRequired,
  radius: PropTypes.number,
  pathOptions: PropTypes.shape({}),
  eventHandlers: PropTypes.shape({}),
};

export default LeafletCircle;
